import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { BuscaComponent } from './imoveis/busca.component';
import { DetalhesImovelComponent } from './imoveis/detalhes-imovel/detalhes-imovel.component';
import { DetalhesCondominioComponent } from './imoveis/detalhes-condominio/detalhes-condominio.component';
import { SobreComponent } from './sobre/sobre.component';
import { TrabalheConoscoComponent } from './trabalhe-conosco/trabalhe-conosco.component';
import { AnuncieComponent } from './anuncie/anuncie.component';
import { ContatoComponent } from './contato/contato.component';
import { CorretoresComponent } from './corretores/corretores.component';
import { TermosUsoComponent } from './termos-uso/termos-uso.component';
import { CorretorExisteGuard } from './guards/corretor-existe.guard';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'anuncie', component: AnuncieComponent },
    { path: 'busca-avancada', component: BuscaComponent },
    { path: 'condominio/:idC', component: DetalhesCondominioComponent }, 
    { path: 'corretor/:idC', component: BuscaComponent, canActivate: [CorretorExisteGuard] }, 
    { path: 'contato', component: ContatoComponent },
    { path: 'imovel/:id', component: DetalhesImovelComponent }, 
    { path: 'sobre', component: SobreComponent },
    { path: 'trabalhe-conosco', component: TrabalheConoscoComponent },
    { path: 'termos', component: TermosUsoComponent },
];
